module.exports = "/_next/static/images/analyticsalt-addb67ff5565e4f1d8a74d9359a7b1b8.svg";